import apiServices from 'config/apiServiceApiGateway'
import type {
  BlacklistPhoneType,
  CustomerOTPReleaseHistoryItemType,
} from 'features/Account/@types/customerOTP'

const { Get, Patch } = apiServices

export type GetCustomerOTPListResponseType = {
  data: {
    blacklist_phones: BlacklistPhoneType[]
  }
  pagination: {
    previous_cursor: string
    next_cursor: string
    next_page_exist: boolean
    previous_page_exist: boolean
  }
}

export type GetCustomerOTPListRequestType = {
  params: {
    cursor: string
    page_size: number
    phone?: string
    is_active?: boolean
    user_type?: string
  }
}

export const getCustomerOTPList = ({ params }: GetCustomerOTPListRequestType) =>
  Get<GetCustomerOTPListResponseType, true>({
    url: '/accounts/internal/v1/blacklist/phone',
    params,
  })

export type PutCustomerOTPRequestType = {
  id: number
  body: { is_active: boolean; released_reason?: string }
}

export type PutCustomerOTPResponseType = {
  data: {
    is_success: true
  }
  error: {
    status: false
    code: 0
    message: ''
  }
}

export const putCustomerOTP = ({ id, body }: PutCustomerOTPRequestType) =>
  Patch<PutCustomerOTPResponseType, true>({
    url: `/accounts/internal/v1/blacklist/phone/${id}`,
    data: body,
  })

export type GetCustomerOTPDetailResponseType = {
  data: {
    blacklist_phone: BlacklistPhoneType
  }
}

export const getCustomerOTPDetail = (id: number) =>
  Get<GetCustomerOTPDetailResponseType, true>({
    url: `/accounts/internal/v1/blacklist/phone/id/${id}`,
  })

export type GetCustomerOTPReleaseHistoryResponseType = {
  data: {
    blacklist_phone_histories: CustomerOTPReleaseHistoryItemType[]
  }
  pagination: {
    previous_cursor: string
    next_cursor: string
    next_page_exist: boolean
    previous_page_exist: boolean
  }
}

export type GetCustomerOTPReleaseHistoryRequestType = {
  params: {
    cursor: string
    page_size: number
    blacklist_phone_number_id: number
  }
}

export const getCustomerOTPReleaseHistory = ({ params }: GetCustomerOTPReleaseHistoryRequestType) =>
  Get<GetCustomerOTPReleaseHistoryResponseType, true>({
    url: '/accounts/internal/v1/blacklist/phone/history',
    params,
  })

export type GetCustomerOTPReleaseReasonsResponseType = {
  data: {
    reasons: string[]
  }
}

export const getCustomerOTPReleaseReasons = () =>
  Get<GetCustomerOTPReleaseReasonsResponseType, true>({
    url: '/accounts/internal/v1/blacklist/phone/release-reasons',
  })
